var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChevronRight1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.52851 3.52827C5.78886 3.26792 6.21097 3.26792 6.47132 3.52827L10.4713 7.52827C10.7317 7.78862 10.7317 8.21073 10.4713 8.47108L6.47132 12.4711C6.21097 12.7314 5.78886 12.7314 5.52851 12.4711C5.26816 12.2107 5.26816 11.7886 5.52851 11.5283L9.05711 7.99967L5.52851 4.47108C5.26816 4.21073 5.26816 3.78862 5.52851 3.52827Z",
    fill: "#D1D1D1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronRight1);
export default __webpack_public_path__ + "static/media/chevron-right1.e1119d7e248ea3d9899428cadb476828.svg";
export { ForwardRef as ReactComponent };